<template>
    <!-- Page Content Wrapper 295x280 -->
    <div id="page-content-wrapper" class="admin-content-area talent-profile">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name mb-2" id="benefitHeader">{{pageTitle}}</div>

                <template v-if="isShow">
                  <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack()">
                  Back</button>
                  <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="print()">
                  <i class="fa fa-print" aria-hidden="true"></i></button>


                  <v-select v-model="userType"
                  v-bind:class="{ disableclick: formPrintHide.userType }"
                        name="type"
                        id="type"
                        label="text"
                        class="pull-right"
                        :clearable="false"
                        :filterable="false"
                        :searchable="false"
                        :options="typeOfUser"
                        @input="selectType(userType)"
                        placeholder="Select Employee Type">
                  </v-select>
                </template>

            </div>
            <div class="admin-page-content" id="pageContentDiv">

              <div class="modal fade" id="viewDetail" role="dialog">
                  <div class="modal-dialog">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h4 class="modal-title" id="defaultModalLabel"> {{ viewTitle }} </h4>
                              <!--<button type="button" class="close" data-dismiss="modal">&times;</button>-->
                          </div>
                          <div class="modal-body">
                              <div class="col-md-12">
                                  <div class="form-group">
                                      {{ viewDetail }}
                                  </div>
                                  <button data-dismiss="modal" type="submit" class="btn btn-primary float-right">Close</button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>


                <form id="talentProfile">
                    <div class="forms-container">
                        <div class="form-row mb-20">
                            <div class="col-sm-3 thumbnail">

                            <template v-if="is_registered">
                              <router-link v-if="isEditProfile" title='Edit User' class="edit-btn-vvg waves-effect float-r"
                                v-bind:to="{name: 'AddUpdateUsers',params:{id:userDetail.id}, query: {from: '9box', year:year}}">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                              </router-link>
                            </template>
                            <template v-if="!is_registered">
                              <!-- <router-link v-if="isEditProfile" title='Edit User' class="btn edit-btn-vvg waves-effect float-r" v-bind:to="{name: 'AddUpdateUsers',params:{id:1525}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link> -->
                              <router-link v-if="isEditProfile" title='Edit User' class="edit-btn-vvg waves-effect float-r"
                                v-bind:to="{name: 'UpdateNotRegisteredUser',params:{id:userDetail.id}, query: {from: '9box', year:year}}">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                              </router-link>
                            </template>
                            <img v-bind:src="userImg">


                            <!--div @click="toggleShow">

                            </div-->



                            <!--my-upload
                                  field="file"
                                  @crop-success="cropSuccess"
                                  @crop-upload-success="cropUploadSuccess"
                                  @crop-upload-fail="cropUploadFail"
                                  v-model="show"
                                  :url="fileUploadUrl"
                                  :headers="headers"
                                  lang-type="en"
                                  :lang-ext="en"
                                  :value.sync="show">
                              </my-upload-->

                                <!--vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        name="file"
                                        >
                                    </vue-dropzone-->
                            </div>
                            <div class="col-sm-9">
                                <div class="profile-section">
                                    <div class="header-block">Profile</div>
                                    <!-- CURRENT TITLE -->
                                    <div class="form-group row no-gutters">
                                        <label class="col-sm-3 col-form-label">Current Title :</label>
                                        <div class="col-sm-9">
                                            <input v-model="currentTitle" type="text" class="form-control" id="currentTitle" placeholder="Enter Current Title"
                                            v-bind:class="{ disableclick: formPrintHide.currentTitle }">
                                        </div>
                                    </div>

                                    <!-- CURRENT LOCATION -->
                                    <div class="form-group row no-gutters">
                                        <label class="col-sm-3 col-form-label">Current Location :</label>
                                        <div class="col-sm-9">
                                            <!--input v-model="currentLocation" type="text" class="form-control" id="currentLocation" placeholder="Enter Current Location"-->
                                            <v-select
                                                v-model="location"
                                                v-bind:class="{ disableclick: formPrintHide.currentLocation }"
                                                name="location"
                                                id="location"
                                                label="text"
                                                :clearable="false"
                                                :filterable="false"
                                                :options="locationArr"
                                                placeholder="Select Location">
                                            </v-select>
                                        </div>
                                    </div>

                                    <!-- TIME IN ROLE -->
                                    <div class="form-group row no-gutters">
                                        <label class="col-sm-3 col-form-label">Time in Role :</label>
                                        <div class="col-sm-9">
                                            <!-- <input v-model="currentRole" type="text" class="form-control" id="currentRole" placeholder="Enter Role">-->
                                            <!--v-select v-model="time_role"
                                                  name="sele_emp"
                                                  id="sele_emp"
                                                  label="text"
                                                  :clearable="false"
                                                  :filterable="false"
                                                  :options="roleArr"
                                                  placeholder="Select Role">
                                            </v-select-->
                                          <input v-model="time_role" type="text" class="form-control"
                                          id="time_role" placeholder="Enter Time in Role"
                                          v-bind:class="{ disableclick: formPrintHide.timeInRole }" autocomplete="off">

                                        </div>
                                    </div>


                                    <!-- DATE OF BIRTH -->
                                    <div class="form-group row no-gutters">
                                        <label class="col-sm-3 col-form-label">Date of Birth :</label>
                                        <div class="col-sm-9" v-bind:class="{ disableclick: formPrintHide.dateOfBirth }">
                                          <!-- <flat-pickr
                                            id="dateofBith"
                                            v-model="dateofBith"
                                            :config="configCalendar"
                                            class="form-control"
                                            placeholder='Enter Date of Birth'
                                            name="dateofBith"
                                            ></flat-pickr> -->
                                          <date-picker
                                              id="dateofBith"
                                              v-model="dateofBith"
                                              :config="configCalendar"
                                              class="form-control"
                                              placeholder='Enter Date of Birth'
                                              name="dateofBith"
                                          ></date-picker>
                                        </div>
                                    </div>

                                </div>
                                <!-- MOBILITY -->
                                <div class="mobility-section">
                                    <div class="header-block">Mobility</div>
                                    <!-- CURRENT MOBILITY -->
                                    <div class="form-group row no-gutters">
                                        <label class="col-sm-3 col-form-label">Now :</label>
                                        <div class="col-sm-9">
                                            <input v-model="currentMobility" type="text" class="form-control" id="currentMobility" placeholder="Enter Current Mobility"
                                            v-bind:class="{ disableclick: formPrintHide.mob_now }">
                                        </div>
                                    </div>
                                    <!-- FUTURE MOBILITY -->
                                    <div class="form-group row no-gutters">
                                        <label class="col-sm-3 col-form-label">2+ Years :</label>
                                        <div class="col-sm-9">
                                            <input v-model="futureMobility" type="text" class="form-control" id="futureMobility" placeholder="Enter Mobility 2+ Years"
                                            v-bind:class="{ disableclick: formPrintHide.mob_years }">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mb-20">
                            <div class="col-md-12">
                                <div class="accomplishment-section">
                                    <div class="header-block">Highlights of Current Accomplishments</div>
                                    <div class="form-group row no-gutters">
                                        <div class="col-sm-12">
                                            <textarea v-model="currentAccomplishment" type="text" class="form-control" id="currentAccomplishment" placeholder="Enter Highlights of Current Accomplishment"></textarea>
                                            <div class="form-control" id="print_helper"></div> <!-- to display the content of textarea full on print view-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mb-20">
                        <!-- KEY STRENGTHS -->
                            <div class="col-md-6">
                                <div class="strengths-section">
                                    <div class="header-block">Key Strengths</div>
                                    <div class="form-group row no-gutters">
                                        <div class="col-sm-12">
                                        <multiselect v-model="keyStrengths"
                                            name="keyStrengths" id="keyStrengths"
                                            label="title"
                                            :options="listKeyStrengths"
                                            :multiple=false
                                            track-by="id"
                                            :taggable="false"
                                            :hideSelected=true
                                            @input="addKeyStrengths(keyStrengths)"
                                            placeholder="Select Key Strengths" class="print-none">
                                        </multiselect>
                                                    <ul class="list-user pt-2 pr-2 pl-4">
                                                          <li v-for="( obj, index) in selectedkeyStrengths" style="list-style: decimal;">
                                                              <!--a href="javascript:void(0)">
                                                              </a-->
                                                              <span>{{ obj.title }}</span>
                                                              <span class="info-circle print-none"><i data-toggle="modal" class="fa fa-info-circle" data-target="#viewDetail" v-on:click.prevent="viewDetailFunc(obj)"></i> </span>
                                                              <span class="pull-right print-none" style="cursor:pointer"><i class="fa fa-times ml-5" aria-hidden="true" v-on:click.prevent="removeStrengths(obj)"></i></span>
                                                              <!---->
                                                          </li>
                                                      </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="futureroles-section">
                                    <div class="row no-gutters">
                                        <div class="col-sm-6">
                                        <!-- FUTURE ROLES -->
                                            <div class="header-block">Future Roles</div>
                                            <div class="form-group row no-gutters pr-1">
                                                <div class="col-sm-12 form-group" id="futureRole1div" v-bind:class="{ disableclick: formPrintHide.futureRole1 }">
                                                     <!-- <input v-model="futureRole1" type="text" class="form-control" id="futureRole1"
                                                     placeholder="Enter Role"
                                                     v-bind:class="{ disableclick: formPrintHide.futureRole1 }"> -->

                                                     <multiselect
                                                        v-model="futureRole1"
                                                        name="cateListActivity"
                                                        :id="futureRole1"
                                                        label="role"
                                                        :options="futureRolesArr"
                                                        :multiple=false
                                                        track-by="role"
                                                        :taggable="true"
                                                        :hideSelected=false
                                                        @tag="futureRoleOne"
                                                        @input="onChange"
                                                        placeholder="Enter Role">
                                                        <template slot="caret">
                                                          <div>
                                                            <div class="multiselect__select" style="display: none;">
                                                            </div>
                                                          </div>
                                                        </template>
                                                      </multiselect>

                                                    <!-- <v-select v-model="futureRole1"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                label="text"
                                                                :clearable="false"
                                                                :filterable="false"
                                                                :options="roleArr"
                                                                placeholder="Select Role">
                                                    </v-select> -->
                                                </div>
                                                <div class="col-sm-12 form-group" id="futureRole2div" v-bind:class="{ disableclick: formPrintHide.futureRole2 }">
                                                     <!-- <input v-model="futureRole2" type="text" class="form-control" id="futureRole1" placeholder="Enter Role"
                                                     v-bind:class="{ disableclick: formPrintHide.futureRole2 }"> -->
                                                    <!--<v-select v-model="futureRole2"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                :clearable="false"
                                                                label="text"
                                                                :filterable="false"
                                                                :options="roleArr"
                                                                placeholder="Select Role">
                                                    </v-select>  -->
                                                    <multiselect
                                                        v-model="futureRole2"
                                                        name="cateListActivity"
                                                        :id="futureRole2"
                                                        label="role"
                                                        :options="futureRolesArr"
                                                        :multiple=false
                                                        track-by="role"
                                                        :taggable="true"
                                                        :hideSelected=false
                                                        @tag="futureRoletwo"
                                                        @input="onChange"
                                                        placeholder="Enter Role">
                                                        <template slot="caret">
                                                          <div>
                                                            <div class="multiselect__select" style="display: none;">
                                                            </div>
                                                          </div>
                                                        </template>
                                                      </multiselect>
                                                </div>
                                                <div class="col-sm-12 form-group" id="futureRole3div" v-bind:class="{ disableclick: formPrintHide.futureRole3 }">
                                                    <!-- <input v-model="futureRole3" type="text" class="form-control" id="futureRole2" placeholder="Enter Role"
                                                    v-bind:class="{ disableclick: formPrintHide.futureRole3 }"> -->
                                                    <!-- <v-select v-model="futureRole3"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                :clearable="false"
                                                                label="text"
                                                                :filterable="false"
                                                                :options="roleArr"
                                                                placeholder="Select Role">
                                                    </v-select> -->

                                                    <multiselect
                                                        v-model="futureRole3"
                                                        name="cateListActivity"
                                                        :id="futureRole3"
                                                        label="role"
                                                        :options="futureRolesArr"
                                                        :multiple=false
                                                        track-by="role"
                                                        :taggable="true"
                                                        :hideSelected=true
                                                        @tag="futureRolethree"
                                                        @input="onChange"
                                                        placeholder="Enter Role">
                                                        <template slot="caret">
                                                          <div>
                                                            <div class="multiselect__select" style="display: none;">
                                                            </div>
                                                          </div>
                                                        </template>
                                                      </multiselect>


                                                </div>
                                                <!--div class="col-sm-12"-->
                                                    <!-- <input v-model="futureRole2" type="text" class="form-control" id="futureRole2" placeholder="5+ Years"> -->
                                                    <!--v-select v-model="sele_empb1"
                                                                @change="changedValue"
                                                                @input="changedValueUser()"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                label="text"
                                                                :filterable="false"
                                                                :options="sele_roleArr"
                                                                @search="onSearchUser"
                                                                placeholder="Select Role">
                                                    </v-select>
                                                </div-->
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="header-block">Timing</div>
                                            <div class="form-group row no-gutters pl-1">
                                                <div class="col-sm-12 form-group">
                                                    <!-- <input v-model="currentRole" type="text" class="form-control" id="currentRole" placeholder="Now"> -->
                                                    <v-select v-model="timing1"
                                                                v-bind:class="{ disableclick: formPrintHide.timing1 }"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                label="text"
                                                                :filterable="false"
                                                                :clearable="false"
                                                                :options="timingArr"
                                                                placeholder="Select Timing">
                                                    </v-select>
                                                </div>
                                                <div class="col-sm-12 form-group">
                                                    <!-- <input v-model="futureRole1" type="text" class="form-control" id="futureRole1" placeholder="1-3 Years"> -->
                                                    <v-select v-model="timing2"
                                                                v-bind:class="{ disableclick: formPrintHide.timing2 }"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                label="text"
                                                                :clearable="false"
                                                                :filterable="false"
                                                                :options="timingArr"
                                                                placeholder="Select Timing">
                                                    </v-select>
                                                </div>
                                                <div class="col-sm-12">
                                                    <!-- <input v-model="futureRole2" type="text" class="form-control" id="futureRole2" placeholder="5+ Years"> -->
                                                    <v-select v-model="timing3"
                                                    v-bind:class="{ disableclick: formPrintHide.timing3 }"
                                                                name="sele_emp"
                                                                id="sele_emp"
                                                                label="text"
                                                                :clearable="false"
                                                                :filterable="false"
                                                                :options="timingArr"
                                                                placeholder="Select Timing">
                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Development Opportunities -->
                        <div class="form-row mb-20">
                            <div class="col-md-12">
                                <div class="development-section">
                                    <div class="header-block">Development Opportunities</div>
                                    <div class="form-group row no-gutters">
                                        <div class="col-sm-12">
                                        <multiselect v-model="opportunities"
                                            name="opportunities" id="opportunities"
                                            label="title"
                                            :options="listKeyStrengths"
                                            :multiple=false
                                            track-by="id"
                                            :taggable="false"
                                            :hideSelected=true
                                            @input="addOpportunities(opportunities)"
                                            placeholder="Select Development Opportunities" class="print-none">
                                        </multiselect>
                                            <!--textarea v-model="developmentOpportunities" type="text" class="form-control" id="developmentOpportunities" placeholder="Enter Development Opportunities"></textarea-->

                                            <ul class="list-user pt-2 pr-2 pl-4">
                                                <li v-for="( obj, index) in selectedOpportunities" style="list-style: decimal;">
                                                    <!--a href="javascript:void(0)">
                                                    </a-->
                                                    <span>{{ obj.title }}</span>
                                                    <span class="info-circle print-none"><i data-toggle="modal" class="fa fa-info-circle" data-target="#viewDetail" v-on:click.prevent="viewDetailFunc(obj)"></i> </span>
                                                    <span class="pull-right print-none" style="cursor:pointer"><i class="fa fa-times ml-5" aria-hidden="true" v-on:click.prevent="removeOpportunities(obj)"></i></span>
                                                    <!---->
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-row mb-20">
                            <div class="col-md-12">
                                <div class="development-section">
                                    <div class="header-block">Education / Certificates</div>
                                    <div class="form-group row no-gutters">
                                        <div class="col-sm-12">
                                            <!--textarea v-model="educationCertificates" type="text" class="form-control" id="educationCertificates" placeholder="Enter Education / Certificates"></textarea-->
                                            <button class="btn btn-primary float-right mt-2 ml-2" v-on:click.prevent="addCertificate()">+</button>

                                            <template v-if="certificateArr.length > 0">
                                                  <button class="btn btn-primary float-right mt-2" v-on:click.prevent="removeCertificate()">-</button>
                                            </template>


                                            <div class="col-sm-4">
                                                <template v-for="( i, index) in certificateArr">
                                                    <input :id="certificateModel.id[index]"
                                                    type="text" class="form-control form-group" placeholder="Enter Certificate"
                                                    @input="setSelected">
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Error Alert-->
                        <div class="alert alert-danger" id="alertError">
                            <strong id="errorMsg" class="error"></strong>
                        </div>
                        <input id="addBenifitBtn" type="submit" value="Update" class="btn btn-primary" v-on:click.prevent="updateTalentProfile()">
                    </div>
                    <!--page content-->
                </form>
            </div>
            <!--End Add Section-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    var self;
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import moment from 'moment';
    import myUpload from 'vue-image-crop-upload';

    import Multiselect from 'vue-multiselect';

    // import flatPickr from 'vue-flatpickr-component';
    // import 'flatpickr/dist/flatpickr.css';

    var afterPrint = function() {
        console.log('Functionality to run after printing');
        $('#futureRole1div').removeClass( "disableclick" ).addClass( "form-group" );
        $('#futureRole2div').removeClass( "disableclick" ).addClass( "form-group" );
        $('#futureRole3div').removeClass( "disableclick" ).addClass( "form-group" );
        if(self.certificateModel.id.length > 0) {
          if($('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).val() == "") {
            console.log("rest", $('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).val() );
            $('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).removeClass( "disableclick" ).addClass( "form-control form-group" );
          }
        }
    };



    export default {
        name: 'TalentProfile',
        props: [''],
        mixins: [SessioMixin],
        components: {
            vueDropzone: vue2Dropzone,
            'datePicker': datePicker,
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
            'my-upload': myUpload,
            Multiselect,
            // flatPickr
        },
        data() {
            return {
                formPrintHide : {
                  currentTitle: false,
                  currentLocation: false,
                  timeInRole: false,
                  dateOfBirth: false,
                  mob_now: false,
                  mob_years: false,
                  currentAccomplishment: false,
                  keyStrength: false,
                  futureRole1: false,
                  futureRole2: false,
                  futureRole3: false,
                  timing1: false,
                  timing2: false,
                  timing3: false,
                  dev_opportunities: false,
                  certificate: false,
                  userType: false,
                },

                userDetail: {},

                viewTitle :'',
                viewDetail :'',

                dateofBith : '',
                configCalendar: {
                    format: 'MM-DD-YYYY',
                    useCurrent: false,
                },
                // configCalendar: {
                //     wrap: false, // set wrap to true only when using 'input-group'
                //     altFormat: 'm-d-Y',
                //     // altFormat: 'Y',
                //     altInput: true,
                //     dateFormat: 'Y-m-d',
                //     enableTime: false,
                //     minDate: null,
                //     maxDate: new Date()

                // },
                opportunities: '',
                selectedOpportunities: [],

                keyStrengths: '',
                listKeyStrengths: [],
                selectedkeyStrengths: [],

                userType: '',
                typeOfUser: ['Associates', 'Managers', 'Technicians'],

                fileUploadUrl: process.env.ROOT_API + "/talent/profile/image_upload",
                en: {
                    hint: 'Click or drag the file here to upload 11',
                    loading: 'Uploading…',
                    noSupported: 'Browser is not supported, please use IE10+ or other browsers',
                    success: 'Upload success',
                    fail: 'Upload failed111',
                    preview: 'Preview',
                    btn: {
                        off: 'Cancel',
                        close: 'Close',
                        back: 'Back',
                        save: 'Save'
                    },
                    error: {
                        onlyImg: 'Image only',
                        outOfSize: 'Image exceeds size limit: ',
                        lowestPx: 'Image\'s size is too low. Expected at least: '
                    }
                },
                show: false,
                params: {
                  token: '123456798',
                  name: 'avatar'
                },
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("api_token"),
                },
                imgDataUrl: '',


                isShow: false,
                userImg: '',
                pageTitle: 'Talent Profile',
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    // acceptedFiles: ".jpg, .jpeg, .png, .mov, .mp4, .mkv",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Insert Picture",
                },

                // V-model
                currentTitle: "",
                currentLocation: "",
                currentRole: "",
                currentMobility: "",
                futureMobility: "",
                currentAccomplishment: "",
                keyStrength: "",
                futureRole1: "",
                futureRole2: "",
                futureRole3: "",
                developmentOpportunities: "",
                educationCertificates: [],
                timing1: '',
                timing2: '',
                timing3: '',
                time_role: "",
                location: '',

                error: "",
                roleArr: [],
                locationArr: [],
                timingArr: ["Now", "1-3 Year", "5+ Year"],
                certificateArr: [],
                certificateModel: {
                  id: []
                },
                userId: 0,
                year: '',

                futureRolesArr: [],

                isEditProfile : false,
                is_registered : false,
            }
        },
        mounted: function () {
            self = this;
            self.getFutureRoles();
            if(this.$route.query.id) {
              self.userId = this.$route.query.id;
              self.isShow = true;
              self.year = this.$route.query.year;
              self.getUserData();
            }
            console.log(self.userId);

            self.checkLogin();
            self.loadRole();
            self.loadLocations();
            var path = window.location.pathname;
            var segments = path.split("/");
            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            $("#login-main-hr").height($(window).height());

            self.loadTalentProfile();

            // self.setRoles();

            // self.userImg = 'https://static.toiimg.com/photo/msid-75805310/75805310.jpg?135092';
        },
        beforeMount() {

        },
        watch: {
        },
        methods: {
            onChange (value) {
              // if(value.id != "new1") {
              //     // self.nameError = "Can't use existing activity name";
              //   }
            },
            futureRoleOne: function (newTag) {
              // console.log(newTag);
              const tag = {
                role: newTag,
                id:'new1' //+ Math.floor((Math.random() * 10000000))
              }
              self.futureRolesArr.push(tag)
              self.futureRole1 = tag;
            },
            futureRoletwo: function (newTag) {
              // console.log(newTag);
              const tag = {
                role: newTag,
                id:'new2' //+ Math.floor((Math.random() * 10000000))
              }
              self.futureRolesArr.push(tag)
              self.futureRole2 = tag;
            },
            futureRolethree: function (newTag) {
              // console.log(newTag);
              const tag = {
                role: newTag,
                id:'new3' //+ Math.floor((Math.random() * 10000000))
              }
              self.futureRolesArr.push(tag)
              self.futureRole3 = tag;
            },
            getFutureRoles: function() {
               var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };


                HTTP.get('talent/profile/future_role', config)
                        .then(function (response) {
                          // console.log(response.data);
                          self.futureRolesArr = response.data;

                          // var jsonObject = self.futureRolesArr.map(JSON.stringify);

                          // console.log("1 == ",jsonObject);

                          // var uniqueSet = new Set(jsonObject);
                          // var uniqueArray = Array.from(uniqueSet).map(JSON.parse);

                          // console.log("2 == ",uniqueArray);

                        })
                        .catch(function (err) {
                            console.log("err == ", err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });

            },
            getUserData: function() {

               var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                      user_id: self.userId
                    }
                };

                self.showLoader();
                HTTP.get('getuserdetail', config)
                        .then(function (response) {
                          self.userDetail = response.data.content;
                          // console.log("user = ", response.data.content);

                          if(response.data.content.is_registered == 0) {
                            self.is_registered = false;
                          } else {
                            self.is_registered = true;
                          }

                          if(response.data.content.profile_image != "" && response.data.content.profile_image != null) {
                            self.userImg =  response.data.content.profile_image;
                            self.isEditProfile = false;
                          } else {
                            var urlSrt = process.env.ROOT_API;
                            urlSrt = urlSrt.replace("/api/v1", "/api/");
                            self.userImg =  urlSrt + "profile_images/placeholder_img.jpeg"
                              self.isEditProfile = true;
                            }
                          // var urlSrt = process.env.ROOT_API;

                          // urlSrt = urlSrt.replace("/api/v1", "/api/");


                          // //
                          // // console.log("img = ",response.data.content.profile_image)
                          // if(response.data.content.profile_image != "" && response.data.content.profile_image != null) {
                          //   self.userImg =  urlSrt + response.data.content.profile_image;
                          //   self.isEditProfile = false;
                          // } else {
                          //   self.userImg =  urlSrt + "profile_images/placeholder_img.jpeg"
                          //   self.isEditProfile = true;
                          // }
                          // console.log(self.userImg);


                          // self.dateofBith = self.userDetail.date_of_birth;
                          self.dateofBith = moment(self.userDetail.date_of_birth).format('MM-DD-YYYY');

                          if(self.userDetail.post != null || self.userDetail.post != "")
                          {
                            // console.log("data == ", self.currentTitle)
                            if(self.currentTitle == "") {
                              self.currentTitle = self.userDetail.post;
                            }

                          };

                          self.hideLoader();
                        })
                        .catch(function (err) {
                            console.log("err == ", err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });

            },
            print() {
              if(self.checkPrintData()) {
                setTimeout(function() { window.print(); },10);

                if (window.matchMedia) {
                      var mediaQueryList = window.matchMedia('print');
                      mediaQueryList.addListener(function(mql) {
                          if (mql.matches) {
                              // beforePrint();
                          } else {
                              afterPrint();
                          }
                      });
                  }
              }
            },
            checkPrintData: function() {
              //     dev_opportunities: false,
              //     certificate: false,
              // console.log("TITIEL ==", self.currentTitle)
              if(self.currentTitle == null || self.currentTitle == "") {
                  self.formPrintHide.currentTitle = true;
              } else {
                self.formPrintHide.currentTitle = false;
                // $('#currentTitle').removeClass( "disableclick" );
              }
              if(self.location == null || self.location == "") {
                self.formPrintHide.currentLocation = true;
              } else {
                self.formPrintHide.currentLocation = false;
              }
              if(self.currentMobility == null || self.currentMobility == "") {
                    self.formPrintHide.mob_now = true;
              } else {
                    self.formPrintHide.mob_now = false;
              }
              if(self.time_role == null || self.time_role == "") {
                    self.formPrintHide.timeInRole = true;
              } else {
                // $('#time_role').removeClass( "disableclick" );
                self.formPrintHide.timeInRole = false;

              }
              if(self.futureMobility == null || self.futureMobility == "") {
                self.formPrintHide.mob_years = true;
              } else {
                self.formPrintHide.mob_years = false;
              }
              // if(self.currentAccomplishment == null || self.currentAccomplishment == "") {
              //   self.formPrintHide.currentAccomplishment = false;
              // }
              if(self.selectedkeyStrengths == null || self.selectedkeyStrengths.length <= 0) {
                self.formPrintHide.keyStrength = true;
              } else {
                self.formPrintHide.keyStrength = false;
              }
              if(self.dateofBith == null || self.dateofBith == '') {
                self.formPrintHide.dateOfBirth = true;
              } else {
                self.formPrintHide.dateOfBirth = false;
              }
              if(self.userType == null || self.userType == "") {
                self.formPrintHide.userType = true;
              } else {
                self.formPrintHide.userType = false;
                // $('#type').removeClass( "disableclick" );
              }
              if(self.timing1 == null || self.timing1 == "") {
                self.formPrintHide.timing1 = true;
              } else {
                self.formPrintHide.timing1 = false;
              }
              if(self.timing2 == null || self.timing2 == "") {
                self.formPrintHide.timing2 = true;
              } else {
                self.formPrintHide.timing2 = false;
              }
              if(self.timing3 == null || self.timing3 == "") {
                self.formPrintHide.timing3 = true;
              } else {
                self.formPrintHide.timing3 = false;
              }
              if(self.futureRole1 == null || self.futureRole1 == "") {
                // self.formPrintHide.futureRole1 = true;
                $('#futureRole1div').removeClass( "form-group" ).addClass( "disableclick" );
              } else {
                // self.formPrintHide.futureRole1 = false;
                $('#futureRole1div').removeClass( "disableclick" ).addClass( "form-group" );
              }
              if(self.futureRole2 == null || self.futureRole2 == "") {
                // self.formPrintHide.futureRole2 = true;
                $('#futureRole2div').removeClass( "form-group" ).addClass( "disableclick" );
              } else {
                // self.formPrintHide.futureRole2 = false;
                $('#futureRole2div').removeClass( "disableclick" ).addClass( "form-group" );
              }
              if(self.futureRole3 == null || self.futureRole3 == "") {
                // self.formPrintHide.futureRole3 = true;
                //
                $('#futureRole3div').removeClass( "form-group" ).addClass( "disableclick" );
              } else {
                // self.formPrintHide.futureRole3 = false;
                $('#futureRole3div').removeClass( "disableclick" ).addClass( "form-group" );
              }
              if(self.certificateModel.id.length > 0) {
                if($('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).val() == "") {
                  console.log("EMPTY", $('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).val() );
                  $('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).removeClass( "form-group" ).addClass( "disableclick" );
                }

              }

              return true;
            },
            viewDetailFunc(obj) {
                self.viewTitle = obj.title;
                self.viewDetail = obj.detail;
            },
            toggleShow() {
              this.show = !this.show;
            },
            cropSuccess(imgDataUrl, field){
              // console.log('-------- crop success --------');
              this.imgDataUrl = imgDataUrl;
            },
            cropUploadSuccess(jsonData, field){
              // console.log('-------- upload success --------');
              // console.log(jsonData);
              console.log('field: ' + field);
            },
            cropUploadFail(status, field){
              // console.log('-------- upload fail --------');
              // console.log(status);
              console.log('field: ' + field);
            },
            buttonBack: function() {
                if (self.$route.query.from == '9box') {
                    self.$router.push('/backend/9box?from=talentprofile');
                } else if (self.$route.query.from == 'talentprofile') {
                    self.$router.push('/backend/list/talentprofile');
                }

            },
            removeCertificate: function() {
              if(self.certificateArr.length > 0) {
                self.certificateArr.pop();
                self.certificateModel.id.pop();
              }
            },
            // setRoles: function() {
            //   console.log("3");
            //   // self.time_role =  self.roleArr.find(obj => obj.value == self.time_role);
            //   self.futureRole1 =  self.roleArr.find(obj => obj.value == self.futureRole1);
            //   self.futureRole2 =  self.roleArr.find(obj => obj.value == self.futureRole2);
            //   self.futureRole3 =  self.roleArr.find(obj => obj.value == self.futureRole3);

            // },
            addCertificate: function() {
              if(self.certificateArr.length < 10) {
                // console.log("box == ", self.certificateModel.id.length);
                if(self.certificateModel.id.length > 0 ) {
                  // console.log("VALE == ", $('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).val());
                  if($('#' + self.certificateModel.id[self.certificateModel.id.length - 1]).val() != "") {
                    self.certificateModel.id.push(self.certificateArr.length);
                    self.certificateArr.push("");
                  }
                } else {
                  self.certificateModel.id.push(self.certificateArr.length);
                  self.certificateArr.push("");
                }
                // self.certificateModel.id.forEach(element => {
                //     // certificates.push($('#' + element).val());
                //     console.log("VALE == ", $('#' + element).val());
                // });

              }
            },
            setSelected(value) {
            },
            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            self.roleArr = response.data.content;
                            var idx = self.roleArr.findIndex(obj => obj.value == 0);
                            self.roleArr.splice(idx, 1);

                            // if(self.time_role !== "" && self.time_role !== undefined) {
                            // self.setRoles();
                            // }
                        })
                        .catch(function (err) {
                          console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            self.locationArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.locationArr.push(response.data.content[i]);

                                    if(self.userDetail != null) {
                                      self.location = self.locationArr.find(obj => obj.id == self.userDetail.location_id);
                                    }
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            selectType: function(val) {
              // console.log("val -=", val);
              var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                      type: val
                    }
                };

                self.showLoader();
                HTTP.get('strengths/get', config)
                        .then(function (response) {
                          self.listKeyStrengths = response.data.content;


                          self.selectedkeyStrengths.forEach(element => {
                            var idx = self.listKeyStrengths.findIndex(obj => obj.id == element.id);
                            if(idx != -1) {
                              self.listKeyStrengths.splice(idx, 1);
                            }

                          });

                          self.selectedOpportunities.forEach(element => {
                            var idx = self.listKeyStrengths.findIndex(obj => obj.id == element.id);
                            if(idx != -1) {
                              self.listKeyStrengths.splice(idx, 1);
                            }

                          });


                          self.hideLoader();
                        })
                        .catch(function (err) {
                            console.log("err == ", err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });

            },
            removeStrengths: function(val) {
              // console.log(val);
              self.listKeyStrengths.push(val);
              var ele = self.selectedkeyStrengths.findIndex(obj => obj.id == val.id);
              self.selectedkeyStrengths.splice(ele, 1);
            },
            removeOpportunities: function(val) {
              // console.log(val);
              self.listKeyStrengths.push(val);
              var ele = self.selectedOpportunities.findIndex(obj => obj.id == val.id);
              self.selectedOpportunities.splice(ele, 1);
            },
            addOpportunities: function(val) {
              this.selectedOpportunities.push(val);
              var ele = self.listKeyStrengths.findIndex(obj => obj.id == val.id);
              self.listKeyStrengths.splice(ele, 1);
              self.opportunities = '';
            },
            addKeyStrengths: function(val) {
              this.selectedkeyStrengths.push(val);
              var ele = self.listKeyStrengths.findIndex(obj => obj.id == val.id);
              self.listKeyStrengths.splice(ele, 1);
              self.keyStrengths = '';
            },
            loadTalentProfile: function() {
                var path = window.location.pathname;
                var segments = path.split("/");

                if(self.userId == 0) {
                    var userObj = localStorage.getItem("user_obj");
                    var userJson = JSON.parse(userObj);
                    self.userId = userJson.id;
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                      userId: self.userId,
                      year: self.year
                    }
                };
                self.showLoader();
                HTTP.get('talent/profile/get', config)
                        .then(function (response) {
                          if(response.data.code == 200) {

                            self.pageTitle = response.data.content.user.first_name + " "
                            + response.data.content.user.last_name + "'s - " + self.pageTitle;

                            self.certificateModel.id = [];
                            self.certificateArr = [];

                            if(self.currentTitle == null || self.currentTitle == "") {
                             self.currentTitle =  response.data.content.title
                            };

                            self.currentMobility =  response.data.content.mobility_now;
                            self.futureMobility = response.data.content.mobility_years;

                            self.location = self.locationArr.find(obj => obj.value == response.data.content.location);
                            self.time_role = response.data.content.role;
                            self.currentAccomplishment = response.data.content.accomplishments;
                            response.data.content.strengths.forEach(element => {
                              self.selectedkeyStrengths.push(element.keystrengths);
                            });
                            response.data.content.opportunities.forEach(element => {
                              self.selectedOpportunities.push(element.keystrengths);
                            });
                            self.userType = response.data.content.type;
                            var i = 0;
                            response.data.content.future_roles.forEach(element => {
                                if(i == 0) {
                                  const tag = {
                                    role: element.role,
                                    id:element.id //+ Math.floor((Math.random() * 10000000))
                                  }
                                  self.futureRole1 = tag;
                                  self.timing1 = element.timing;
                                } else if(i == 1) {
                                  const tag = {
                                    role: element.role,
                                    id:element.id //+ Math.floor((Math.random() * 10000000))
                                  }
                                  self.futureRole2 = tag;
                                  self.timing2 = element.timing;
                                } else if(i == 2) {
                                  const tag = {
                                    role: element.role,
                                    id:element.id //+ Math.floor((Math.random() * 10000000))
                                  }
                                  self.futureRole3 = tag;
                                  self.timing3 = element.timing;
                                }
                                i++;
                            });
                            self.educationCertificates = response.data.content.certificates;
                            i = 0;
                            self.educationCertificates.forEach(element => {
                                  self.certificateModel.id.push(i);
                                  self.certificateArr.push("certificate" + i);
                                  i++;
                                });

                              Vue.nextTick(function () {
                                i = 0;
                                self.educationCertificates.forEach(element => {
                                  $('#' + self.certificateModel.id[i]).val(element.certificate);
                                  i++;
                                });
                            });
                            // console.log("roll =", self.time_role);
                            // if(self.roleArr.length > 0) {
                            //     self.setRoles();
                            //     console.log("2");
                            // }


                          } else {

                            // console.log()
                            self.pageTitle = response.data.content.first_name + " "
                            + response.data.content.last_name + "'s - " + self.pageTitle;
                          }

                          self.hideLoader();
                          // to display the content of textarea full on print view
                            function copy_to_print_helper(){
                                $('#print_helper').text(self.currentAccomplishment);
                            }
                            $('#currentAccomplishment').bind('keydown keyup keypress cut copy past blur change', function(){
                                copy_to_print_helper(); // consider debouncing this to avoid slowdowns!
                            });
                            copy_to_print_helper();
                        })
                        .catch(function (err) {
                            console.log("err == ", err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            formCheck: function() {
              var checked = true;
              if(self.currentTitle == null || self.currentTitle == '') {
                $("#errorMsg").html("Current Title Missing");
                $(".alert-danger").removeClass("hide");
                $(".alert-danger").addClass("show");
                checked = false;
              }
              if(self.time_role == null || self.time_role == '') {
                $("#errorMsg").html("Time in Role Missing");
                $(".alert-danger").removeClass("hide");
                $(".alert-danger").addClass("show");
                checked = false;
              }
              if(self.location == null || self.location == '') {
                $("#errorMsg").html("Location is Missing");
                $(".alert-danger").removeClass("hide");
                $(".alert-danger").addClass("show");
                checked = false;
              }
              return checked;
            },
            updateTalentProfile: function() {
              if(self.userType == null || self.userType == '') {
                self.$swal({
                    type: 'error',
                    text: 'Please Select Employee Type',
                    showConfirmButton: false,
                });
              } else {

                if(self.formCheck()) {
                  $("#errorMsg").html("");
                  $(".alert-danger").removeClass("show");
                  $(".alert-danger").addClass("hide");

                  $("#addBenifitBtn").val("Updating ...");
                  $("#addBenifitBtn").prop("disabled", true);
                  var config = {
                      headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                  };

                  var stregnth = [];
                  self.selectedkeyStrengths.forEach(element => {
                    stregnth.push(element.id);
                  });

                  var opportunities = [];
                  self.selectedOpportunities.forEach(element => {
                    opportunities.push(element.id);
                  });
                  var futureRoles = [];
                  if(self.futureRole1 != "" && self.futureRole1 != null) {
                    var obj = {
                      role : self.futureRole1.role,
                      timing : self.timing1,
                    };
                    futureRoles.push(obj);
                  }

                  if(self.futureRole2 != "" && self.futureRole2 != null) {

                    var obj = {
                      role : self.futureRole2.role,
                      timing : self.timing2,
                    };
                    futureRoles.push(obj);
                  }

                  if(self.futureRole3 != null && self.futureRole3 != '') {

                    var obj = {
                      role : self.futureRole3.role,
                      timing : self.timing3,
                    };
                    futureRoles.push(obj);
                  }


                  var certificates = [];

                  self.certificateModel.id.forEach(element => {
                      certificates.push($('#' + element).val());
                  });

                  if(self.year == '') {
                    var dt = new Date();
                    var year = dt.getFullYear();
                    self.year = year;
                  }


                  var data = {
                      title: self.currentTitle,
                      emp_id : self.userId,
                      mobility_now: self.currentMobility,
                      mobility_years: self.futureMobility,
                      accomplishments: self.currentAccomplishment,
                      opportunities: opportunities,
                      strengths: stregnth,
                      future_roles: futureRoles,
                      certificates: certificates,
                      year: self.year,
                      type: self.userType,
                      // date_of_birth: self.dateofBith
                      date_of_birth: moment(self.dateofBith, 'MM-DD-YYYY').format('YYYY-MM-DD')
                  };
                  if(self.location != null && self.location != '') {
                    data['location'] = self.location.value;
                  }

                  if(self.time_role != null && self.time_role != '') {
                    data['role'] =  self.time_role;
                  }
                  self.showLoader();
                  HTTP.post("talent/profile/update", data, config)
                      .then(function (response) {
                          $("#addBenifitBtn").val("Update");
                          $("#addBenifitBtn").prop("disabled", false);
                          if (response.data.status == "success") {
                              // self.loadTalentProfile();
                              self.$swal({
                                  type: 'success',
                                  text: 'Talent Profile Update Successfully',
                                  showConfirmButton: true,
                              });
                          } else {

                            // var res = JSON.parse(response.data.message);
                            console.log("ERROR MAYUR", response.data.message);
                            $("#alertError").show();
                              $("#errorMsg").html(response.data.message);
                              if (response.data.message.length > 0) {
                                  var err = "";
                                  for (var i = 0; i < response.data.message.length; i++) {
                                        err += response.data.message[i] + "<br>";
                                    }
                                    console.log("ERROR SHOW", err);
                                  $("#errorMsg").html(err);
                                  $(".alert-danger").removeClass("hide");
                                  $(".alert-danger").addClass("show");
                              }
                          }
                          self.hideLoader();
                      })
                      .catch(function (err) {
                          self.hideLoader();
                          $("#addBenifitBtn").val("Update");
                          $("#addBenifitBtn").prop("disabled", false);
                          if (err.response.status == 0) {
                              self.error = "Remote server can not be reachable";
                          } else {
                              $('#errorMsg').html(err.response.data.message);
                          }
                      });

                }
              }
            },
            removedSelectedFile(file, xhr, error) {},
            vfileSuccess(file, response) {},

        }
    }
</script>

<style>

.edit-activity .multiselect__select {
  display: none;
}

    /* .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
    .block-future-role {
        float: left;
        width: 100%;
        margin: 0 0 15px 0;
        padding: 0;
        font-weight: normal;
        font-size: 28px;
        /* color: #0f467c; *
        color: #000;
        font-family: 'SanFranciscoDisplay-Bold';
    } */
    .talent-profile .dropdown-toggle::after { display: none;}
    .talent-profile .header-block{background-color:#2E8EE2;padding:10px;color:#fff;text-transform: uppercase;float: left;width: 100%;}
    .talent-profile .thumbnail{min-height:200px;}
    .talent-profile .dropzone.dz-clickable{margin:0;min-height: 300px;}
    .talent-profile .form-group{margin-bottom: 0.5rem;}
    .talent-profile .v-select.unsearchable{width:17%;}
    .talent-profile .v-select.unsearchable .dropdown-toggle{height: 41px;}
    .talent-profile .v-select.unsearchable .selected-tag{line-height: 37px;height: 41px;}
    .talent-profile .v-select.unsearchable input[type=search]{opacity:1;}
    .talent-profile .futureroles-section .form-group .v-select{padding-right:15px; margin-bottom: 0;}
    .talent-profile .form-group .v-select.searchable .dropdown-toggle,.talent-profile .multiselect__tags{border: 0;border-radius: 0;border-bottom: 1px solid #dddddd;}
    .talent-profile .form-group label{font-size: 14px;}
    .talent-profile .form-group .form-control{height: 35px;font-size: 0.8rem;}
    .talent-profile .form-group textarea{min-height:150px;}
    .talent-profile .list-user li{font-size: 16px;margin-bottom: 5px;color: #565655;}
    .talent-profile .list-user .info-circle{font-size: 13px;vertical-align: text-top;margin-left: 5px;}
    .talent-profile  #print_helper {display: none;}
    .talent-profile .form-group .v-select input[type=search] {height: 34px;}
    .talent-profile .multiselect{min-height: 35px;max-height: 35px;}
    .talent-profile .multiselect__tags{min-height: 35px;max-height: 35px;padding: 6px 40px 0 8px;}
    .talent-profile .multiselect__placeholder{margin-bottom: 5px;padding-top: 0;}
    @media only screen and (max-width:812px){
        .talent-profile .page-header-top-container .back_button{margin-bottom: 5px;}
        .talent-profile .header-block{padding: 5px;font-size: 14px;}
        .talent-profile .dropzone.dz-clickable{min-height: unset;margin-bottom: 10px;}
        .talent-profile .form-group textarea{min-height:80px;}
        .talent-profile .v-select.unsearchable{width:100%;}
    }
    @media print {
        .talent-profile .v-select .selected-tag{border: 0;}
        .talent-profile .form-group .v-select input[type=search] {height: 34px;}
        .disableclick{ display: none; }
        .navbar, #sidebar-wrapper,.admin-footer,.btn,.print-none,
        .talent-profile .v-select .dropdown-toggle .vs__actions,.talent-profile textarea{display:none !important;}
        #wrapper{padding-left: 0;margin-top: 0;}
        .forms-container{border:0 none;padding: 0;}
        .talent-profile{font-size: 18pt;}
        .talent-profile .header-block{color: #212529; font-weight: bold;}
        .talent-profile .form-group{display:block;clear:both;margin-bottom:10px;}
        .talent-profile .form-group label{font-size: 16pt;padding-left: 10px;}
        .talent-profile .list-user {margin: 8pt 8pt 0 24pt;}
        .talent-profile .form-group .form-control,
        .talent-profile .v-select .selected-tag,
        .talent-profile .multiselect__placeholder,
        .talent-profile .list-user li{font-size: 18pt;}
        .talent-profile .v-select.unsearchable .dropdown-toggle{position:unset;}
        .talent-profile input,.talent-profile  #print_helper,.talent-profile .v-select.unsearchable .dropdown-toggle {border: none ;border-bottom: 1px solid gray;box-shadow: none !important;outline: none !important;}
        .talent-profile  #print_helper {display: block;overflow: visible;white-space: pre-wrap;height: auto;}
        .admin-content-area .page-header-top-container .page-name {font-weight: bold;}
        .talent-profile .multiselect__placeholder{margin-bottom: 0;line-height: 25px;}
        .talent-profile .multiselect__single{font-size:25px;}
    }
</style>



// WEBPACK FOOTER //
// src/components/backend/talentprofile/TalentProfile.vue